import { Role } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props extends ChakraV3.TagProps {
  role: Role;
}

export const RoleTag = (props: Props) => {
  const { role, ...rest } = props;

  switch (role) {
    case Role.Support:
      return (
        <ChakraV3.Tag colorPalette='cyan' {...rest}>
          Support
        </ChakraV3.Tag>
      );
    case Role.Administrator:
      return (
        <ChakraV3.Tag colorPalette='brand' {...rest}>
          Administrator
        </ChakraV3.Tag>
      );
    case Role.TeamLeader:
      return (
        <ChakraV3.Tag colorPalette='blue' {...rest}>
          Team Leader
        </ChakraV3.Tag>
      );
    case Role.TeamMember:
      return (
        <ChakraV3.Tag colorPalette='green' {...rest}>
          Team Member
        </ChakraV3.Tag>
      );
  }
};
